<template lang="pug">
  .exchange-picker__container
    .exchange-list__container(v-loading="isLoading")
      .title Для продолжения выберите обменник
      .exchange__container(v-for="exchange in exchanges")
        el-button(@click="pickExchange(exchange)") {{ exchange.name }}

</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_EXCHANGES, SET_EXCHANGE } from "../../store/const/settings";
export default {
  name: 'ExchangePicker',
  data() {
    return {}
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('settings', {
      exchanges: 'exchanges',
    }),
    isLoading() {
      return this.loading(LOAD_EXCHANGES) === 'loading';
    },
  },
  methods: {
    ...mapActions('settings', {
      setExchange: SET_EXCHANGE
    }),
    pickExchange(exchange) {
      this.setExchange({ exchange });
    }
  }
}
</script>
<style>
.exchange-picker__container {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  background-color: #c5c5c5;
}
.exchange-list__container {
  width: fit-content;
  height: fit-content;
  padding: 30px;
  background-color: #f1f1f1;
  border: 1px solid black;
  box-shadow: 1px 1px 1px #7d7d7d;
  text-align: center;
}
.exchange-list__container .title {
  padding-bottom: 5px;
  border-bottom: 1px solid #7d7d7d;
}
.exchange__container {
  margin: 10px auto;
}
</style>
